import React from 'react'
import {  FaTwitter, FaLinkedin, FaInstagram } from "react-icons/fa";
import "./Footer.scss"

const Footer = () => {
  return (
    <div className="Footer">
    <div className="Footer_Left">
      <h2>About Us:</h2>
      <p>When I look into the eyes of an animal I do not see an animal. I see a living being. I see a friend. I feel a soul. Since they can't speak, let us become their voice!</p>
      <p>Created with ❤️ by team Paltu!</p>
      <h3>© {new Date().getFullYear()} Paltu. All rights reserved.</h3>
    </div>
    <div className="Footer_Right">
      <h2> Contact Us:</h2>
      <div className="Footer_Icons">
        <a title='Instagram' href="http://instagram.com/perfectly_imperfect_sid?igshid=YmMyMTA2M2Y=" target="_blank" rel="noreferrer">
        <FaInstagram
              size={35}
              style={{ color: "#1f1f1f", marginTop: "1rem" }}
            />
        </a>
        <a title='LinkedIn' href="http://www.linkedin.com/in/siddharth-mishra-363194225" target="_blank" rel="noreferrer">
        <FaLinkedin
              size={35}
              style={{ color: "#1f1f1f", marginTop: "1rem" }}
            />
        </a>
        <a title='Twitter' href="http://twitter.com/Siddhu0509?t=QTCaR_p09WzsFXq1_LwDIQ&s=08" target="_blank" rel="noreferrer">
        <FaTwitter
              size={35}
              style={{ color: "#1f1f1f", marginTop: "1rem" }}
            />
        </a>
      </div>
    </div>
  </div>
  )
}

export default Footer